import * as React from "react"
import { Link } from "react-router-dom"
import Stack from 'react-bootstrap/Stack';
import {NavigationBar, Layout} from "./layout"
import { Typography } from "@mui/material";

// navigation bar covers master's head in the image
// do not show image until it is fixed
const heroBanner=<div style={{ display: "grid" }}>
<img
  style={{
    gridArea: "1/1",
    // maxHeight: 600,
  }}
  layout="fullWidth"
  aspectRatio={2 / 1}
  alt=""
  src="/chanqiBanner.png"
  quality="40"
  formats={["auto", "webp", "avif"]}/>
<div
  style={{
    gridArea: "1/1",
    position: "relative",
    placeItems: "center",
    display: "grid",
  }}
>
</div>
</div>;

const ChanQi = () => {
  let poster=<Stack direction="horizontal" gap={4}>
  <img src="/chanqi-thumbnail.png" width={420} />
  <img src="/chanqi-thumbnail-winter.png" width={420} /></Stack>;

if((typeof window !== 'undefined') && window.screen.width< 667) {
  poster=  <><img src="/chanqi-thumbnail.png" width={"100%"} />
  <img src="/chanqi-thumbnail-winter.png" width={"100%"} />
  </>;

}

  return (
  <><NavigationBar/>
  {heroBanner}
{/* Main Content */}
  <Layout>
  {poster}
<div><Typography variant="h3">靜坐禪修（禪七）</Typography><br/>
<Typography variant="body1">
<strong>夏季：2023年6月17日晚上9點 - 2023年7月8日上午11點</strong><br/>
地址：法藏寺 （3201 Ulloa St San Francisco, CA 94116）<br/><br/>
​<strong>冬季：2023年11月25日晚上9點-2023年12月30日上午11點</strong><br/>
地址：溈山寺 （7732 Emerson Place Rosemead, CA 91770）<br/>
<strong>冬季：2023年12月30日晚上9點-2024年2月3日上午11點</strong><br/>
地址：法藏寺 （3201 Ulloa St San Francisco, CA 94116）<br/><br/>

每日講座時間改為：<br/>
星期一至星期四禪修开示：<b>晚上7：20</b><br/>
星期五至星期日佛經講座：<b>晚上7：20</b><br/>
<b>暫停亞洲禪修課&星期二賢池師誦咒課，其他課程照常。<br/>
週日上午的法會安排會另行通知。</b><br/><br/>
我們精進的禪七提供了難得的機會，在我們的道場體驗真正的傳統禪宗修行：Rosemead的溈山寺、San Jose的金林禪修中心、韓國的寶山寺和寶螺禪修中心。至誠精進的同修們會體驗到人生的改變: 改善健康，提升專注力(禪定力)，並在佛陀的開悟和智慧之路上取得進展。<br/><br/>
日本和西方國家被稱為Zen的修行，發源於產宗佛教。傳統的禪七強度很大，我們建議參與者盡可能地遵循時間表，如有需要可以額外休息。<br/><br/>
對在<Link to="/leavehome">寺院修行</Link>感興趣人來說，禪七是在 <Link to="/master">永化法師</Link>的指導下體驗修行的絕佳機會。 參加禪七之前，根據 <Link to="/publication">永化法師《禪修手冊》</Link>練習坐禪，有助於您準備好參加禪七。<br/><br/>
您可以來坐一坐、一天、一周或者全程參加。歡迎您同我們一起修禪，歡迎隨喜捐款贊助禪七。<br/><br/>
請<a href="https://www.chanpureland.org/32852319952510520204.html" target="_blank">聯繫我們</a>登記參加禪七或諮詢掛單。​<br/><br/></Typography></div>

<a href="/chanqi-schedule.png"><img src="/chanqi-schedule.png" /></a>

  </Layout>
  </>
)}

export default ChanQi
